import { Component, OnInit, ElementRef, Renderer, ViewChild, ChangeDetectorRef, HostListener } from '@angular/core';
import { DomSanitizer, SafeResourceUrl, SafeUrl, SafeHtml} from '@angular/platform-browser';
import { ActivatedRoute, Router, NavigationEnd } from '@angular/router';
import { Observable } from 'rxjs/Rx';

import { environment } from '../../environment';
import { StoreService } from '../../services/store.service';
import { UserService } from '../../services/user.service';

import { incomingCards, staggeredCards, CartOverlay, parentCategories, childCategories } from '../animations';

import { Currency } from '../../models/currency';
import { Category } from '../../models/category';
import { Item } from '../../models/item';

import { Filter } from '../../models/filter.constructor';

@Component({
  selector: 'browser',
  templateUrl: './browser.component.html',
  animations: [ incomingCards, staggeredCards, CartOverlay, parentCategories, childCategories ]
})
export class BrowserComponent implements OnInit {

	title: string;
	header: any;
	headerHeight: any;
	headerAlign: any;
	subtitle: string;
	subtitleLink: string;
	cart: any[];
	custom: any;
	customizer: any;
	items: Item;
	allitems: Item;
	total: number;
	cartItems: any;
	showCards: string;
	searching: boolean;
	flashCart: boolean;
	itemsOnPage: number;
	hideHeader: boolean;
	subtitleIcon: string;
	viewCategory: string;	
	loadingCart: boolean;
	selectedImage = 0;
	numberOfItems: string;
	currencyOpen: any;
	filtersActive: boolean;
	selectedCategory: string;
	displayParentCategories = true;
	displayChildCategories = false;
	loadingItemDetails = false;
	categoriesOnPage: number;
	currency: Currency;
	currencies: Currency;
	enableCurrencySelector = false;
	categories: Category;
	itemquery = new Filter();
	parentcategories: Category;
	selectedItem = 0;
	childIndex = 0;
	showItemDetails = 'false';

	constructor(private storeService: StoreService,
				private userService: UserService,
				private route: ActivatedRoute,
				private sanitizer: DomSanitizer,
				private router: Router,
				private cdr: ChangeDetectorRef,
				private element: ElementRef,
  				private renderer: Renderer) {
	}




	/**
	* Updating Page Items
	**/

	updateCategory( category ) {
		this.itemquery.category = category.id;
		this.refreshItems();
	}

	updateChildCategory( category ) {
		this.refreshItems();
	}

	refreshItems() {
		Promise.resolve( this.storeService.getItems( this.itemquery ) ).then( (cats) => {
			this.items = cats;
		});
	}


	viewItem(i, cat) {
		this.selectedItem = i; 
		this.selectedImage = 0; 
		this.showItemDetails = 'true';
		this.itemquery.category = cat;
	}


	/**
	* Cart Handling
	**/

	addToCart(item, i) {
		
		if (!item.owned && !this.inCart(item.id) ) {
			this.storeService.addItem(item.id);
			this.updateCartButton();
			this.loadingCart = true;
			this.getCart();
		}

		if ( this.inCart(item.id) ) this.router.navigate(['/checkout']);
	}

	inCart( listingidentifier ) {
		var exists = ( this.cart.indexOf( listingidentifier ) > -1 ) ? true : false;
		return exists;
	}

	removeFromCart(itemIndex) {
		this.storeService.removeItem(itemIndex);
		this.getCart();
	}

	getCart() {
		// this.addedtocart.emit('complete');
		this.custom = this.storeService.getItemContents();
		this.cart = this.storeService.getCartContents();
		this.getTotal();
	}

	getTotal() {
		Promise.resolve(this.storeService.getCustomizerTotal()).then(t => 
			this.total = t
		);
	}

	updateCartButton() {
		this.flashCart = true;
		setTimeout( () => { this.flashCart = false;  }, 5000);
	}

	addItem(item) {
		this.storeService.addItem(item.id);
	}

	subtractItem(item) {
		this.storeService.removeItem(item.id);
	}

	hideDetails() {

		
	}


	/**
	* Item Selecting
	**/
	toggleItem(item) {

		if ( this.isSelected(item) ) {
			this.subtractItem(item);
		} else {
			this.addItem(item);
		}

	}

	isSelected(item) {
		let found = false;
		for (var i = this.cartItems.length - 1; i >= 0; i--) {
			if (this.cartItems[i].id == item.id) 
				found = true;
		}
		return found;
	}

	



	/**
	* Currency Handling
	**/
	getCurrencies() {
		Promise.resolve( this.storeService.getCurrencies() ).then((c) => {
			this.currencies = c;
		});

		Promise.resolve( this.storeService.getCurrency() ).then((c) => {
			this.currency = c[0];
		});

		Promise.resolve(this.storeService.enableCurrencySelector()).then((bool) => {
			this.enableCurrencySelector = bool;
		});
	}

	changeCurrency(currenc) {
		this.currency = currenc;
		this.currencyOpen = -1;
		this.storeService.changeCurrency(currenc);
	}


	/**
	* Animations
	**/ 

	addItemsToPage() {
		this.itemsOnPage = this.itemsOnPage+6;
	}

	areFiltersActive( type ) {
		if ( this[type+'query'].sort != 'ASC' ) {
			return true;
		} else if ( this[type+'query'].category != null ) {
			return true;
		} else if ( this[type+'query'].filterItems != null ) {
			return true;
		} else {
			return false;
		}
	}

	stagger(t = 67) {
		if (this.showCards < this.numberOfItems) {
			this.showCards = this.showCards+1;
			// this.showCards = this.showCards+1;
			// setTimeout( () => {
			// 	this.stagger(t);
			// }, t);
		} else { 
			this.showCards = this.numberOfItems;
		}
	}




	addCategory() { 
		this.categoriesOnPage = this.categoriesOnPage + 1;
	}

  	@HostListener('window:scroll', ['$event'])
		public onWindowScroll(event: Event): void {
		event.preventDefault();
		var distanceFromBottom = document.body.scrollHeight - window.innerHeight - window.scrollY
		if( distanceFromBottom < 300 ) { this.addCategory(); }
  	}

	ngOnInit() {

  		this.title = 'Category Browser';
		this.headerHeight = '350px';
		this.header = this.sanitizer.bypassSecurityTrustStyle( 'url( "/assets/img/video/video.jpg") 10%' );
		this.subtitle = 'Equip your character for survival';
		this.itemquery.sort = 'asc';
		this.itemquery.category	= null;
		this.categoriesOnPage = 5;
		this.addCategory();

		/**
		* Get Details for this particular Item
		* Accept URL Parameter /:id
		**/
		this.router.events
			.filter(event => event instanceof NavigationEnd)
			.map(() => this.router.routerState.root)
			.subscribe((event) => {
				this.viewCategory = this.route.snapshot.params['id'];
			});


		this.cart = this.storeService.getCartContents();

		Promise.resolve( this.storeService.getActiveCategories() ).then( (cats) => {
			this.categories = cats;
		});

		this.refreshItems();

	}

}


// WEBPACK FOOTER //
// C:/Users/Asylum/identity-vagrant/src/asylum-idenetity/src/app/store/browser/browser.component.ts